import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Input, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaCurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput";

import { formatCurrency } from '../../../functions/functions';

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tipoDeDocumento_id: null,
            provincia_id: null,
            localidad_id: null,
            tazaInteres_venta: 0,
            tazaInteres_servicio: 0,
            tazaInteres_escritura: 0,
            cantidadDecimales: 2,
            caracterDecimales: ',',
            caracterMiles: '.',
            activeTab: 1,
            diaVencimientoCuotas: 10,
            postVariables: [
                'tipoDeDocumento_id',
                'provincia_id',
                'localidad_id',
                'tazaInteres_venta',
                'tazaInteres_servicio',
                'tazaInteres_escritura',
                'cantidadDecimales',
                'caracterDecimales',
                'caracterMiles',
                'diaVencimientoCuotas'
            ],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
    }

    resetForm() {
        this.setState({
            tipoDeDocumento_id: null,
            provincia_id: null,
            localidad_id: null,
            tazaInteres_venta: 0,
            tazaInteres_servicio: 0,
            tazaInteres_escritura: 0,
            cantidadDecimales: 2,
            caracterDecimales: ',',
            caracterMiles: '.',
            activeTab: 1,
            diaVencimientoCuotas: 10,
            errors: [],
        });
    }

    getData() {
        const { postVariables } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });

        return data;
    }

    setData(data) {
        if (data.success) {
            this.setState({
                tipoDeDocumento_id: (data.tipoDeDocumento ? data.tipoDeDocumento.id : null),
                provincia_id: (data.provincia ? data.provincia.id : null),
                localidad_id: (data.localidad ? data.localidad.id : null),
                tazaInteres_venta: data.tazaInteres_venta,
                tazaInteres_servicio: data.tazaInteres_servicio,
                tazaInteres_escritura: data.tazaInteres_escritura,
                cantidadDecimales: data.cantidadDecimales,
                caracterDecimales: data.caracterDecimales,
                caracterMiles: data.caracterMiles,
                diaVencimientoCuotas: data.diaVencimientoCuotas,
            });
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    onSubmit = data => {
        if (data.success) {
            localStorage.configuraciones = JSON.stringify(data);
        }
    }

    render() {
        const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];
        return (
            <ParadigmaModal
                getUrl={api.config.default}
                submitUrl={api.config.default}
                submitType="PUT"

                onGotData={data => this.setData(data)}
                onGotErrors={errors => this.setErrors(errors)}
                onClose={_ => this.resetForm()}
                onPreSubmit={_ => this.getData()}
                onSubmit={data => this.onSubmit(data)}

                title="Editar Configuraciones"

                successMessage="Las Configuraciones han sido editadas con éxito."
                missingIdMessage="Debe seleccionar una fila."
                saveButtonLabel="Guardar"
                buttonTitle="Editar"
                buttonIcon="fa fa-pencil fa-lg"
                saveButton={true}
                closeButton={true}

                navButton
                nav={this.props.nav}
                className="ui-paradigma-modal ui-paradigma-modal-wide ui-modal-with-tabs"
            >

                <Nav tabs className="ui-modal-tabs">
                    <NavItem>
                        <NavLink
                            className={(this.state.activeTab == 1 ? "active" : "")}
                            onClick={() => { this.setState({ activeTab: 1 }) }}
                        >General</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={(this.state.activeTab == 2 ? "active" : "")}
                            onClick={() => { this.setState({ activeTab: 2 }) }}
                        >Contable</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={(this.state.activeTab == 3 ? "active" : "")}
                            onClick={() => { this.setState({ activeTab: 3 }) }}
                        >Numérico</NavLink>
                    </NavItem>
                </Nav>

                <TabContent
                    activeTab={this.state.activeTab}
                    className="ui-modal-tab-content">

                    <TabPane tabId={1}>
                        <section className="ui-modal-section">
                            <p className="ui-section-label">General</p>
                            <div className="ui-form-grid">
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Tipo Documento"}
                                    error={() => this.getError('tipoDeDocumento_id')}
                                    inputComponent={
                                        <ParadigmaAsyncSeeker
                                            url={api.configuracion.tiposdedocumento}
                                            parameters={{
                                                paginationEnabled: false,
                                            }}
                                            value={this.state.tipoDeDocumento_id}
                                            onChange={(data) => this.onChangeField('tipoDeDocumento_id', data ? data.id : null)}
                                        />
                                    }
                                />
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Provincia"}
                                    error={() => this.getError('provincia_id')}
                                    inputComponent={
                                        <ParadigmaAsyncSeeker
                                            url={api.geograficas.provincias}
                                            parameters={{
                                                paginationEnabled: false,
                                            }}
                                            value={this.state.provincia_id}
                                            onChange={(data) => this.onChangeField('provincia_id', data ? data.id : null)}
                                        />
                                    }
                                />
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Localidad"}
                                    error={() => this.getError('localidad_id')}
                                    inputComponent={
                                        <ParadigmaAsyncSeeker
                                            url={this.state.provincia_id ? api.geograficas.localidades : ''}
                                            parameters={{
                                                paginationEnabled: false,
                                                concat: this.state.provincia_id ? `provincia=${this.state.provincia_id}` : ''
                                            }}
                                            value={this.state.localidad_id}
                                            onChange={(data) => this.onChangeField('localidad_id', data ? data.id : null)}
                                        />
                                    }
                                />
                            </div>
                        </section>
                    </TabPane>

                    <TabPane tabId={2}>
                        <section className="ui-modal-section">
                            <p className="ui-section-label">Contable</p>
                            <div className="ui-form-grid">
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Tasa de interés Venta (Mensual)"}
                                    error={() => this.getError('tazaInteres')}
                                    inputComponent={
                                        <ParadigmaCurrencyInput
                                            className="form-control monto w-100"
                                            value={formatCurrency(this.state.tazaInteres_venta)}
                                            onChange={data => this.onChangeField('tazaInteres_venta', data)}
                                        />
                                    }
                                />

                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Tasa de interés Servicio (Mensual)"}
                                    error={() => this.getError('tazaInteres_servicio')}
                                    inputComponent={
                                        <ParadigmaCurrencyInput
                                            className="form-control monto w-100"
                                            value={formatCurrency(this.state.tazaInteres_servicio)}
                                            onChange={data => this.onChangeField('tazaInteres_servicio', data)}
                                        />
                                    }
                                />

                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Tasa de interés Escritura (Mensual)"}
                                    error={() => this.getError('tazaInteres_escritura')}
                                    inputComponent={
                                        <ParadigmaCurrencyInput
                                            className="form-control monto w-100"
                                            value={formatCurrency(this.state.tazaInteres_escritura)}
                                            onChange={data => this.onChangeField('tazaInteres_escritura', data)}
                                        />
                                    }
                                />

                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Día de Vencimiento de Cuotas"}
                                    error={() => this.getError('diaVencimientoCuotas')}
                                    inputComponent={
                                        <Input
                                            className="text-right"
                                            value={this.state.diaVencimientoCuotas}
                                            onChange={e => {
                                                e.persist();
                                                const value = e.target.value;
                                                this.setState(prevState => ({
                                                    diaVencimientoCuotas: value === '' || (/^\d*$/.test(value) && Number(value) >= 1 && Number(value) < 31) ? value : prevState.diaVencimientoCuotas
                                                }))
                                            }}
                                        />
                                    }
                                />
                            </div>
                        </section>
                    </TabPane>

                    <TabPane tabId={3}>
                        <section className="ui-modal-section">
                            <p className="ui-section-label">Numérico</p>
                            <div className="ui-form-grid">
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Cantidad decimales"}
                                    error={() => this.getError('cantidadDecimales')}
                                    inputComponent={
                                        <Input
                                            className="text-right"
                                            value={this.state.cantidadDecimales}
                                            onChange={e => {
                                                e.persist();
                                                this.setState(prevState => ({
                                                    cantidadDecimales: /^\d*$/.test(e.target.value) ? e.target.value : prevState.cantidadDecimales
                                                }))
                                            }}
                                        />
                                    }
                                />
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Caracter decimales"}
                                    value={this.state.caracterDecimales}
                                    maxLength={1}
                                    onChange={(e) => this.onChangeField('caracterDecimales', e.target.value)}
                                    error={() => this.getError('caracterDecimales')}
                                />
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Caracter miles"}
                                    value={this.state.caracterMiles}
                                    maxLength={1}
                                    onChange={(e) => this.onChangeField('caracterMiles', e.target.value)}
                                    error={() => this.getError('caracterMiles')}
                                />
                            </div>
                        </section>
                    </TabPane>

                </TabContent>
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Configuracion/Configuraciones/Modal.js